import React from "react";
import PropTypes from "prop-types";
// Material Imports
import Typography from "@mui/material/Typography";
import makeStyles from "@mui/styles/makeStyles";
import ActionIcon from "@mui/icons-material/Send";
import ActionCompleteIcon from "@mui/icons-material/Done";
import Grid from "@mui/material/Grid";
//Limitless imports
import { useCustomerMessageContext } from "../../../hooks";
import ActionInput from "../../forms/action-input/ActionInput";
const useStyles = makeStyles({
  dialogueContainer: {
    backgroundColor: "#fff",
    marginLeft: 32,
    marginRight: 32,
    borderRadius: 10,
    padding: 16,
    marginBottom: 32
  },
  marginText: {
    marginTop: 16
  }
});
const DEFAULT_ITEM_VALUE = {
  pristine: true,
  value: ""
};
const SecureDataDialogue = ({
  t,
  dialogue,
  message
}) => {
  const classes = useStyles();
  const [itemValue, setItemValue] = React.useState(DEFAULT_ITEM_VALUE);
  const [regexTest, setRegexTest] = React.useState(true);
  const {
    secureData
  } = dialogue;
  const {
    options
  } = secureData;
  const secureDataItem = options[0];
  const {
    name,
    placeholder,
    validationRegex
  } = secureDataItem;
  const {
    messageId,
    accessKey
  } = message;
  const regex = new RegExp(validationRegex);
  const {
    submitSecureData,
    fetchMessage
  } = useCustomerMessageContext();
  React.useEffect(() => {
    setRegexTest(regex.test(itemValue.value));
  }, [itemValue]);
  const sendData = () => {
    currentAction.complete.state = true;
    submitSecureData({
      dialogueId: dialogue.dialogueId,
      customerSecData: [{
        valueName: name,
        value: itemValue.value
      }]
    }, () => {
      fetchMessage(messageId, accessKey);
    });
  };
  const DEFAULT_ACTION = {
    icon: ActionIcon,
    onActionClick: sendData,
    complete: {
      state: secureData.completed,
      icon: ActionCompleteIcon
    },
    canSubmit: true
  };
  const currentAction = DEFAULT_ACTION;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.dialogueContainer
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    style: {
      marginBottom: 8
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    color: "textSecondary"
  }, t("Please provide your details below to get further assistance:"))), /*#__PURE__*/React.createElement(Grid, {
    item: true
  }, /*#__PURE__*/React.createElement(ActionInput, {
    secureData: secureData,
    name: "secureData",
    label: name,
    placeholder: placeholder || t("Please enter requested data"),
    id: "secureDataField",
    onChange: event => setItemValue({
      value: event.target.value,
      pristine: false
    }),
    error: !itemValue.pristine && !regexTest,
    helperText: !itemValue.pristine && !regexTest && t("Value is not valid."),
    value: itemValue.value,
    action: currentAction,
    t: t
  })));
};
export default SecureDataDialogue;
SecureDataDialogue.propTypes = {
  dialogue: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  isReported: PropTypes.bool,
  message: PropTypes.object.isRequired,
  actionIcon: PropTypes.node
};
SecureDataDialogue.defaultProps = {
  isReported: false
};